import "../../global.css";
import * as React from "react";
import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userRequest } from "../../requestMethods";
import { useCompany } from "../../components/context/CompanyContext";
import { titleSetRef } from "../../redux/titleRedux";
import Loading from "../../components/loading/loading";
import CustomGrid from "../../components/grid/CustomGrid";
import {
  CART_PERIODS as PERIODOS,
  DEFAULT_CART_PERIOD,
  buildAnaliticoCartsBody,
} from "../../util/cartPeriod";

export default function CartList() {
  const [searchParams] = useSearchParams();
  const currentUser = useSelector((state) => state.user.currentUser);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [time, setTime] = useState(
    () => searchParams.get("time") || DEFAULT_CART_PERIOD
  );
  const { companyId, slug } = useCompany();
  const from = searchParams.get("from");
  const nav = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(titleSetRef({ title: "Carrinho" }));
  }, [dispatch]);

  useEffect(() => {
    if (companyId > 0) {
      getCarts(time);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId, time]);

  const storeStories =
    (!currentUser?.isAdmin || currentUser?.position === "Gerente") && currentUser?.storeId
      ? [currentUser.storeId]
      : [];

  const getCarts = async (timeFilter) => {
    setIsLoading(true);
    try {
      const res = await userRequest.post(
        `${companyId}/reportCarts/analiticoCarts`,
        buildAnaliticoCartsBody({ time: timeFilter, stories: storeStories })
      );
      setData(Array.isArray(res.data) ? res.data : []);
    } catch {
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      field: "name",
      type: "text",
      headerName: "Nome",
      width: 200,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "contact",
      type: "text",
      headerName: "Contato",
      width: 130,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "quantity",
      type: "number",
      headerName: "Qtde de produtos",
      width: 120,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "total",
      type: "number",
      headerName: "Total",
      width: 150,
      format: "BRL",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "managedBy",
      type: "text",
      headerName: "Vendedor(a)",
      width: 200,
      align: "left",
      headerAlign: "center",
    },
    {
      field: "createdAt",
      type: "date",
      headerName: "Criada em",
      width: 160,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy HH:mm:ss",
    },
    {
      field: "updatedAt",
      type: "date",
      headerName: "Atualizada em",
      width: 160,
      align: "center",
      headerAlign: "center",
      format: "dd/MM/yyyy HH:mm:ss",
    },
  ];

  return (
    <div className="cust-page">
      {from && (
        <div
          onClick={() => nav(`/${slug}/${from}`)}
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
            marginBottom: 12, cursor: "pointer",
            color: "#6B7280", fontSize: 13, fontWeight: 600, fontFamily: "Manrope",
            padding: "6px 12px", borderRadius: 8,
            border: "1px solid #E5E7EB", background: "#fff",
            boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
          }}
        >
          ← Voltar para Indicadores
        </div>
      )}
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
            {PERIODOS.map((p) => (
              <button
                key={p.value}
                onClick={() => setTime(p.value)}
                style={{
                  padding: "4px 12px",
                  borderRadius: 8,
                  border: "1px solid #E5E7EB",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                  fontFamily: "Manrope",
                  background: time === p.value ? "#EE8253" : "#fff",
                  color: time === p.value ? "#fff" : "#6B7280",
                  transition: "all 0.2s",
                }}
              >
                {p.label}
              </button>
            ))}
          </div>
          <CustomGrid
            gridId="cartListAnalitico"
            rows={data}
            columns={columns}
            pageSize={45}
            checkboxSelection={false}
            tableHeight="calc(100vh - 110px)"
          />
        </>
      )}
    </div>
  );
}
